import React from 'react';
import { Container, Row } from 'reactstrap';
import EmptyBuildings from './components/EmptyBuildings';

const EmailConfirmation = ( props ) => (
  <Container>
    <Row className={`${props.small ? 'small' : ''}`}>
    
	    <EmptyBuildings />
    
      
    </Row>
  </Container>
);

export default EmailConfirmation;
